import React from "react";
import { Stepper, Step, StepLabel, StepConnector, stepConnectorClasses } from "@mui/material";
import { styled } from "@iventis/styles";
import { GeoReferencerCadMode } from "../types/georeferencer-cad-mode";

const STEP_CLIP_LAYERS = { label: "Clip and exclude layers", mode: GeoReferencerCadMode.ClippingAndLayerExclusions };
const STEP_LOCATION = { label: "Select location", mode: GeoReferencerCadMode.LocationPicker };
const STEP_POSITION = { label: "Position CAD", mode: GeoReferencerCadMode.Positioning };
const STEP_EXCLUDE_LAYERS = { label: "Exclude layers", mode: GeoReferencerCadMode.LayerExclusions };
const STEP_PERIMETER = { label: "Set perimeter", mode: GeoReferencerCadMode.Perimeter };

interface ModeStepperComponentProps {
    mode: GeoReferencerCadMode;
    georeferenced: boolean;
}

export const ModeStepperComponent: React.FC<ModeStepperComponentProps> = ({ mode, georeferenced }) => {
    const steps = georeferenced ? [STEP_CLIP_LAYERS, STEP_EXCLUDE_LAYERS, STEP_PERIMETER] : [STEP_CLIP_LAYERS, STEP_LOCATION, STEP_POSITION, STEP_EXCLUDE_LAYERS, STEP_PERIMETER];

    return (
        <StepperContainer>
            <Stepper activeStep={steps.findIndex((step) => step.mode === mode)} alternativeLabel connector={<ProgressConnector />}>
                {steps.map((step) => (
                    <Step key={step.label}>
                        <StepLabel>{step.label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </StepperContainer>
    );
};

const StepperContainer = styled.div`
    padding: 10px;
`;

const ProgressConnector = styled(StepConnector)`
    &.${stepConnectorClasses.alternativeLabel} {
        top: 10px;
        left: calc(-50% + 16px);
        right: calc(50% + 16px);
    }

    &.${stepConnectorClasses.active} .${stepConnectorClasses.line} {
        position: relative;
        background-color: #eaeaf0;
        overflow: hidden;

        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 0%;
            height: 100%;
            background-image: linear-gradient(95deg, ${({ theme }) => theme.primaryColors.focus} 0%, ${({ theme }) => theme.primaryColors.focusAccent} 100%);
            animation: fillLine 1.5s ease-in-out forwards;
        }
    }

    &.${stepConnectorClasses.completed} .${stepConnectorClasses.line} {
        background-image: linear-gradient(95deg, ${({ theme }) => theme.primaryColors.focus} 0%, ${({ theme }) => theme.primaryColors.focusAccent} 100%);
    }

    .${stepConnectorClasses.line} {
        height: 3px;
        border: 0;
        background-color: #eaeaf0;
        border-radius: 1px;
    }

    @keyframes fillLine {
        from {
            width: 0;
        }
        to {
            width: 100%;
        }
    }
`;
